import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { calcBurnDown, formatDay } from '../../lib/utils';
import { useMilestone } from '../../lib/hooks';
import { chartTooltip, chartCursor, axisTick, gridStroke } from '../../lib/chartTheme';

const BurnDown = (props) => {

    const [mode, setMode] = useState('Time');

    const formatTick = (lab) => {
        if (mode === 'Time') {
            return formatDay(lab);
        }
        return lab;
    };

    const milestone = useMilestone();
    const buttons = ['Count', 'Weight', 'Time'];
    const chartData = calcBurnDown(props.issueList, mode.toLowerCase(), milestone);

    return (
        <div className="ds-panel">
            <div className="ds-panel__head">
                <h3 className="ds-panel__title">Sprint Burndown</h3>
                <div className="ds-seg" role="tablist" aria-label="Burndown metric">
                    {buttons.map(b => (
                        <button
                            key={b}
                            type="button"
                            role="tab"
                            aria-selected={mode === b}
                            className={`ds-seg__btn${mode === b ? ' is-active' : ''}`}
                            onClick={() => setMode(b)}
                        >
                            {b}
                        </button>
                    ))}
                </div>
            </div>
            <div className="dash-chart">
                <ResponsiveContainer width="100%" aspect={20.0 / 9.0}>
                    <LineChart margin={{ top: 20, left: 8, right: 16, bottom: 8 }} data={chartData}>
                        <CartesianGrid stroke={gridStroke} strokeDasharray="4 4" vertical={false} />
                        <XAxis dataKey="name" tick={axisTick} tickLine={false} axisLine={{ stroke: gridStroke }} />
                        <YAxis tickFormatter={formatTick} tick={axisTick} tickLine={false} axisLine={false} width={64} />
                        <Line type="monotone" name="Open" dataKey="open" stroke="#1f9d5b" strokeWidth={2} dot={false} activeDot={{ r: 4 }} />
                        <Line type="monotone" name="Added" dataKey="added" stroke="#3a3aed" strokeWidth={2} dot={false} activeDot={{ r: 4 }} />
                        <Line type="monotone" strokeDasharray="5 5" activeDot={{ r: 4 }} name="Ideal" dataKey="ideal" stroke="#8a8698" strokeWidth={2} dot={false} />
                        <Legend iconType="plainline" wrapperStyle={{ fontSize: '12px', paddingTop: '8px' }} />
                        <Tooltip {...chartTooltip} cursor={chartCursor} formatter={formatTick} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default BurnDown;
